(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[908],{

/***/ 3444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ Carousel_Carousel; }
});

// UNUSED EXPORTS: CarouselCard

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Carousel/CarouselCard.tsx


var CarouselCard = function CarouselCard(_ref) {
  var children = _ref.children,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: customClass,
    children: children
  });
};

/* harmony default export */ var Carousel_CarouselCard = (CarouselCard);
;// CONCATENATED MODULE: ./components/Carousel/Carousel.tsx




var scrollBarWidthREM = 16;
var scrollProgressWidthREM = 4;

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      _ref$isWidthScreen = _ref.isWidthScreen,
      isWidthScreen = _ref$isWidthScreen === void 0 ? false : _ref$isWidthScreen,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? 'start' : _ref$justify;

  var _useState = (0,react.useState)(0),
      progress = _useState[0],
      setProgress = _useState[1];

  var _useState2 = (0,react.useState)(true),
      showProgress = _useState2[0],
      setShowProgress = _useState2[1];

  var handleScroll = function handleScroll(event) {
    var _event$target$scrollL, _event$target, _event$target$scrollW, _event$target2, _event$target$clientW, _event$target3;

    var left = (_event$target$scrollL = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.scrollLeft) !== null && _event$target$scrollL !== void 0 ? _event$target$scrollL : 0;
    var scrollWidth = (_event$target$scrollW = event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.scrollWidth) !== null && _event$target$scrollW !== void 0 ? _event$target$scrollW : 1;
    var clientWidth = (_event$target$clientW = event === null || event === void 0 ? void 0 : (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.clientWidth) !== null && _event$target$clientW !== void 0 ? _event$target$clientW : 0;
    setProgress(left / (scrollWidth - clientWidth));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col px-12",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: function ref(el) {
        return setShowProgress((el === null || el === void 0 ? void 0 : el.clientWidth) < (el === null || el === void 0 ? void 0 : el.scrollWidth));
      },
      className: "".concat(isWidthScreen ? 'w-screen' : 'w-full', " lg:w-full px-4 flex gap-[0.625rem] justify-").concat(justify, " overflow-x-scroll scrollbar-none scroll-smooth"),
      onScroll: handleScroll,
      children: children.map(function (child) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_CarouselCard, {
          children: child
        }, child.key);
      })
    }), showProgress && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center items-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative mt-[23px]",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "h-[4px] rounded-full bg-neutral-300",
          style: {
            width: "".concat(scrollBarWidthREM, "rem")
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "absolute h-[4px] rounded-full bg-red-600 left-0 top-0",
          style: {
            width: "".concat(scrollProgressWidthREM, "rem"),
            transform: "translate(".concat(progress * (scrollBarWidthREM - scrollProgressWidthREM), "rem, 0)")
          }
        })]
      })
    })]
  });
};

/* harmony default export */ var Carousel_Carousel = (Carousel);
;// CONCATENATED MODULE: ./components/Carousel/index.ts



/***/ }),

/***/ 4193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ e_memo; }
});

// EXTERNAL MODULE: ./components/_OldDesign/header.tsx + 1 modules
var header = __webpack_require__(6627);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/_OldDesign/content.tsx + 1 modules
var content = __webpack_require__(3714);
// EXTERNAL MODULE: ./utils/translate.ts
var translate = __webpack_require__(954);
// EXTERNAL MODULE: ./models/conent.ts
var conent = __webpack_require__(3290);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/_OldDesign/productHeader.tsx
var productHeader = __webpack_require__(2111);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(6529);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var styles = __webpack_require__(6494);
// EXTERNAL MODULE: ./styles/Content.module.scss
var Content_module = __webpack_require__(8369);
var Content_module_default = /*#__PURE__*/__webpack_require__.n(Content_module);
// EXTERNAL MODULE: ./components/_OldDesign/OldLayout.tsx + 1 modules
var OldLayout = __webpack_require__(4990);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./components/shared/FormContact.tsx + 7 modules
var FormContact = __webpack_require__(7878);
// EXTERNAL MODULE: ./components/Common/index.ts + 2 modules
var Common = __webpack_require__(4565);
// EXTERNAL MODULE: ./components/Carousel/index.ts + 2 modules
var Carousel = __webpack_require__(3444);
// EXTERNAL MODULE: ./components/Contexts/TailwindBreakpointContext.tsx + 4 modules
var TailwindBreakpointContext = __webpack_require__(9806);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/eMemo/ValueOfMoney.tsx








var filters = {
  blue: 'linear-gradient(180deg, rgba(29, 29, 29, 0.90) 0%, rgba(41, 173, 206, 0.90) 100%)',
  black: 'linear-gradient(180deg, rgba(29, 29, 29, 0.8) 0%, #1D1D1D 100%)'
};
var cards = [{
  icon: {
    src: '/images/ememo/infinity.svg',
    alt: 'infinity'
  },
  background: {
    src: '/images/ememo/nolimit-bg.webp',
    filter: filters.blue
  },
  title: {
    en: 'No Limit',
    th: 'ใช้งานไม่จำกัด'
  },
  details: [{
    en: 'Unlimited Users',
    th: 'ไม่จำกัดจำนวนผู้ใช้งาน'
  }, {
    en: 'Unlimited Documents',
    th: 'ไม่จำกัดจำนวนเอกสาร'
  }, {
    en: 'Unlimited LOA/DOA',
    th: 'ไม่จำกัดสายอนุมัติ LOA/DOA'
  }]
}, {
  icon: {
    src: '/images/ememo/paintcan.svg',
    alt: 'paintcan'
  },
  background: {
    src: '/images/ememo/customization-bg.webp',
    filter: filters.black
  },
  title: {
    en: 'Customization & White-labeling',
    th: 'ปรับแต่งได้ตามต้องการ และรองรับการทำ White-label'
  },
  details: [{
    en: 'Customizable interface with your theme and logo',
    th: 'ปรับแต่งธีมสีและโลโก้ได้ตามต้องการ'
  }, {
    en: 'Initial setup of approval chains',
    th: 'ตั้งค่าลำดับการอนุมัติเบื้องต้นได้อย่างง่ายดาย'
  }]
}, {
  icon: {
    src: '/images/ememo/customer-support.svg',
    alt: 'customer-support'
  },
  background: {
    src: '/images/ememo/implementation-bg.webp',
    filter: filters.blue
  },
  title: {
    en: 'Implementation, Training & Support',
    th: 'บริการติดตั้งระบบ พร้อมอบรมและดูแลอย่างใกล้ชิด'
  },
  details: [{
    en: 'Two training sessions',
    th: 'อบรมการใช้งานระบบ 2 ครั้ง'
  }, {
    en: 'Two week UAT',
    th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E23\u0E30\u0E1A\u0E1A UAT ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "2 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"]
    })
  }, {
    en: 'After-sales technical support via call center',
    th: 'บริการหลังการขาย พร้อมทีมเทคนิคคอยให้คำปรึกษาทาง Call Center'
  }]
}, {
  icon: {
    src: '/images/ememo/multiple-pages.svg',
    alt: 'multiple-pages'
  },
  background: {
    src: '/images/ememo/included-forms-bg.webp',
    filter: filters.black
  },
  title: {
    en: 'Included Forms',
    th: 'แบบฟอร์มสำเร็จรูป พร้อมใช้งานทันที'
  },
  details: [{
    en: 'Internal approval form',
    th: 'แบบฟอร์มการขออนุมัติภายใน'
  }, {
    en: 'External approval form',
    th: 'แบบฟอร์มการขออนุมัติภายนอก'
  }, {
    en: 'Procurement Form',
    th: 'แบบฟอร์มการขออนุมัติการซื้อ'
  }]
}];

var ValueOfMoney = function ValueOfMoney() {
  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screenWidth = _useTailwindBreakpoin.screenWidth;

  var _useState = (0,react.useState)(null),
      initWidth = _useState[0],
      setInitWidth = _useState[1];

  (0,react.useEffect)(function () {
    setInitWidth(window.innerWidth);
  }, []);
  (0,react.useEffect)(function () {
    if (screenWidth) {
      setInitWidth(null);
    }
  }, [screenWidth]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "text-4xl xl:text-xl font-bold gradient-head text-center my-[40px]",
      children: "Value of Money"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        justify: initWidth >= 1280 || screenWidth >= 1280 ? 'center' : 'start',
        children: cards.map(function (_ref) {
          var icon = _ref.icon,
              background = _ref.background,
              title = _ref.title,
              details = _ref.details;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "relative bg-no-repeat bg-cover bg-center w-[270px] min-h-[335px] h-full rounded-[40px] p-[10px] text-white",
            style: {
              background: "".concat(background.filter, ", url(").concat(background.src, ")"),
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex justify-center rounded-full bg-white w-[56px] h-[56px] mb-[16px]",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  alt: icon.alt,
                  src: icon.src,
                  width: 36,
                  height: 36
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-[18px] font-semibold mb-[24px] h-[56px]",
                children: lang === 'en' ? title.en : title.th
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "flex flex-col gap-[12px]",
                children: details.map(function (detail) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "flex gap-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "min-w-[24px] -mt-[2px]",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        alt: "check",
                        src: "/images/ememo/check-round-fill.svg",
                        width: 24,
                        height: 24
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-[16px] font-light",
                      children: lang === 'en' ? detail.en : detail.th
                    })]
                  }, detail.en);
                })
              })]
            })
          }, title.en);
        })
      })
    })]
  });
};

/* harmony default export */ var eMemo_ValueOfMoney = (ValueOfMoney); // style={{ background:
//   'linear-gradient(180deg, rgba(29, 29, 29, 0.90) 0%, rgba(41, 173, 206, 0.90) 100%),
//   url(${background.src})',
// backgroundSize: 'cover',
// backgroundRepeat: 'no-repeat',
// backgroundPosition: 'center'
//  }}
;// CONCATENATED MODULE: ./components/eMemo/index.ts

;// CONCATENATED MODULE: ./pages/e-memo.tsx


















var responsive = {
  superLargeDesktop: {
    breakpoint: {
      max: 5000,
      min: 3000
    },
    items: 1
  },
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 1
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464
    },
    items: 1
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0
    },
    items: 1
  }
};
var imgClass = 'm-auto h-96 xl:h-56 relative z-10';
var graphicEMemoDir = '/images/ememo/Graphic e-Memo';
var graphicEMemoFiles = ['Always Online, Effortless Access!', 'Approval in Just One Click!', 'Attach Files!', 'Communicate Instantly with the Comment Box!', 'No Longer Need the Document?', 'Reject with a Reason!', 'Store locally or on Cloud, Access Anywhere!'];

function getGraphicEMemoImage(title) {
  var plainTitle = title === null || title === void 0 ? void 0 : title.replace(/<[^>]*>/g, ' ').trim();
  var fileName = graphicEMemoFiles.find(function (name) {
    return plainTitle === null || plainTitle === void 0 ? void 0 : plainTitle.includes(name);
  });
  return fileName && "".concat(graphicEMemoDir, "/").concat(encodeURIComponent("".concat(fileName, ".png")));
}

var EmemoPage = function EmemoPage(_ref) {
  var _contents$find, _filterContent, _filterContent2, _contents$find2, _filterContent3, _contents$filter, _findContent;

  var contents = _ref.contents;

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang,
      setLang = _useLocale.setLang;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      scroll = _useState[0],
      setScroll = _useState[1];

  (0,react.useEffect)(function () {
    var _localStorage$getItem;

    var defaultLocale = (_localStorage$getItem = localStorage.getItem('lang')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'th';
    setLang(defaultLocale);
  }, [router]);

  function scrollToContact() {
    setScroll(!scroll);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header/* default */.Z, {
      content: {
        title: 'e-Memo by CODIUM - ระบบจัดการเอกสารและเซ็นอนุมัติออนไลน์',
        content: 'CODIUM e-Memo ระบบจัดการเอกสารออนไลน์ครบวงจร พร้อม e-Signature เซ็นอนุมัติเอกสารได้ทุกที่ ทุกเวลา สอดคล้องตามข้อกฎหมาย เพิ่มประสิทธิภาพการทำงานขององค์กร',
        image: null
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(productHeader/* default */.Z, {
      headerItem: contents === null || contents === void 0 ? void 0 : contents.find(function (item) {
        return item.name === "Ememo Header";
      }),
      click: scrollToContact
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "px-24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
        contents: (0,translate/* titleOnly */.rT)(contents === null || contents === void 0 ? void 0 : contents.find(function (item) {
          return item.name === "why memo";
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 relative xl:grid-cols-4",
        children: contents === null || contents === void 0 ? void 0 : (_contents$find = contents.find(function (item) {
          return item.name === "why memo";
        })) === null || _contents$find === void 0 ? void 0 : _contents$find.subContent.map(function (d, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: i % 2 === 1 ? 'mt-12' : '',
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
                contents: d
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/ememo/bg-content.svg",
              className: "hidden absolute top-8 z-10 xl:block ".concat(i % 2 === 1 ? 'top-[5rem]' : ''),
              alt: "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E15\u0E48\u0E32\u0E07\u0E46\u0E40\u0E02\u0E49\u0E32\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E07\u0E48\u0E32\u0E22\u0E14\u0E32\u0E22",
              loading: "lazy"
            })]
          }, i);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
        contents: contents.find(function (item) {
          return item.name === 'See E-Memo at Work';
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_multi_carousel["default"], {
        responsive: responsive,
        className: "mx-16 xl:mx-32",
        children: contents.find(function (item) {
          return item.name === 'See E-Memo at Work';
        }).subContent.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        }).map(function (sub, subIndex) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-wrap sm:flex-nowrap justify-center items-center sm:px-24",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex-col text-center focus:outline-none relative mx-auto align-self-center w-2/3 sm:w-5/12",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: getGraphicEMemoImage(sub.title),
                className: "mx-auto w-full",
                alt: sub.title,
                loading: "lazy"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex-col text-center m-auto w-full sm:w-6/12",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "text-dark-blue mt-12 mb-4 prometo font-bold text-5xl sm:text-4xl md:text-3xl",
                dangerouslySetInnerHTML: {
                  __html: (0,translate/* translate */.Iu)(sub, 'title', lang)
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "jamjuree thai-lh text-4xl sm:text-2xl md:text-xl my-5",
                lang: "th",
                dangerouslySetInnerHTML: {
                  __html: (0,translate/* translate */.Iu)(sub, 'description', lang)
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
                  id: "contact-us-ememo",
                  icon: "/icons/speech.svg",
                  text: lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา',
                  className: "text-sm border border-white",
                  onClick: scrollToContact
                })
              })]
            })]
          }, subIndex);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
        contents: (0,translate/* titleOnly */.rT)(contents === null || contents === void 0 ? void 0 : contents.find(function (item) {
          return item.name === "FEATURES";
        }).subContent.find(function (item) {
          return item.type === "title";
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-16 xl:px-24",
        children: (_filterContent = (0,translate/* filterContent */.OC)(contents, 'Content')) === null || _filterContent === void 0 ? void 0 : _filterContent.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        }).map(function (d, i) {
          var _d$image$, _d$image$2, _d$image$3, _d$image$4, _d$image$5, _d$image$6, _d$image$7, _d$image$8;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "hidden relative bg-no-repeat ".concat(i % 2 === 0 ? 'bg-left' : 'bg-right', " z-10 bg-left grid-row-2 xl:grid-cols-2 xl:grid pt-4 px-16 mx-4 my-16 xl:h-76"),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(conent.be).concat((_d$image$ = d.image[1]) === null || _d$image$ === void 0 ? void 0 : _d$image$.url),
              className: "absolute ".concat(i % 2 === 0 ? 'left-0' : 'right-0', " "),
              alt: (_d$image$2 = d.image[1]) === null || _d$image$2 === void 0 ? void 0 : _d$image$2.alternativeText,
              loading: "lazy"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat(i % 2 === 0 ? ' xl:block' : 'xl:hidden'),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-full  xl:flex",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "".concat(conent.be).concat((_d$image$3 = d.image[0]) === null || _d$image$3 === void 0 ? void 0 : _d$image$3.url),
                  className: "".concat(imgClass, " ").concat((_d$image$4 = d.image[0]) !== null && _d$image$4 !== void 0 && _d$image$4.url.includes('svg') ? 'h-72' : ''),
                  "data-aos": "fade-right",
                  "data-aos-duration": "1000",
                  alt: (_d$image$5 = d.image[0]) === null || _d$image$5 === void 0 ? void 0 : _d$image$5.alternativeText,
                  loading: "lazy"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "m-auto",
              children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
                contents: d
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "hidden xl:block ".concat(i % 2 === 1 ? '' : 'xl:hidden'),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-full bg-no-repeat z-10 bg-center xl:flex",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "".concat(conent.be).concat((_d$image$6 = d.image[0]) === null || _d$image$6 === void 0 ? void 0 : _d$image$6.url),
                  className: "".concat(imgClass, " ").concat((_d$image$7 = d.image[0]) !== null && _d$image$7 !== void 0 && _d$image$7.url.includes('svg') ? 'h-72' : ''),
                  "data-aos": "fade-left",
                  "data-aos-duration": "1000",
                  alt: (_d$image$8 = d.image[0]) === null || _d$image$8 === void 0 ? void 0 : _d$image$8.alternativeText,
                  loading: "lazy"
                })
              })
            })]
          }, i);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "lg:grid xl:hidden",
        children: [" ", (_filterContent2 = (0,translate/* filterContent */.OC)(contents, 'Content')) === null || _filterContent2 === void 0 ? void 0 : _filterContent2.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        }).map(function (d, i) {
          var _d$image$9, _d$image$10, _d$image$11, _d$image$12;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "grid grid-row-2 ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full  bg-no-repeat  z-10 bg-center my-8",
              style: {
                backgroundImage: "url(".concat(conent.be).concat((_d$image$9 = d.image[1]) === null || _d$image$9 === void 0 ? void 0 : _d$image$9.url, ")")
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "".concat(conent.be).concat((_d$image$10 = d.image[0]) === null || _d$image$10 === void 0 ? void 0 : _d$image$10.url),
                className: "".concat(imgClass, " ").concat((_d$image$11 = d.image[0]) !== null && _d$image$11 !== void 0 && _d$image$11.url.includes('svg') ? 'h-84 xl:64' : ''),
                alt: (_d$image$12 = d.image[0]) === null || _d$image$12 === void 0 ? void 0 : _d$image$12.alternativeText,
                loading: "lazy"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
              contents: d
            })]
          }, i);
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex w-full font-light justify-center  relative text-4xl pt-8 px-8 textGrey xl:text-xl xl:my-0 xl:mb-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat(contents !== null && contents !== void 0 && contents.textColor ? "text-".concat(contents.textColor) : (Content_module_default()).textSecondary, " text-center my-8 relative typing"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: (_contents$find2 = contents.find(function (item) {
              return item.title === 'Find out more details';
            })) === null || _contents$find2 === void 0 ? void 0 : _contents$find2.description
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Content_module_default()).titleLine1,
            "data-aos": "zoom-in-left",
            "data-aos-delay": "1000",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/homepage/title-line.svg",
              alt: "CODIUM \u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E40\u0E17\u0E04\u0E42\u0E19\u0E42\u0E25\u0E22\u0E35\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E0A\u0E32\u0E0D\u0E09\u0E25\u0E32\u0E14\u0E43\u0E19\u0E22\u0E38\u0E04\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25",
              className: " xl:h-auto",
              loading: "lazy"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Content_module_default()).titleLine2,
            "data-aos": "zoom-in-right",
            "data-aos-delay": "1000",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/homepage/title-line1.svg",
              alt: "CODIUM \u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E40\u0E17\u0E04\u0E42\u0E19\u0E42\u0E25\u0E22\u0E35\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E0A\u0E32\u0E0D\u0E09\u0E25\u0E32\u0E14\u0E43\u0E19\u0E22\u0E38\u0E04\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25",
              className: " xl:h-auto",
              loading: "lazy"
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(eMemo_ValueOfMoney, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full text-center mt-16 md:mt-12 xl:mt-14 mb-24 md:mb-20 flex justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
          id: "contact-us-ememo",
          icon: "/icons/speech.svg",
          text: lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา',
          className: "text-sm border border-white",
          onClick: scrollToContact
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hidden xl:block xl:px-24",
        children: (_filterContent3 = (0,translate/* filterContent */.OC)(contents, 'FAQ')) === null || _filterContent3 === void 0 ? void 0 : _filterContent3.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        }).map(function (d, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "relative bg-no-repeat m-auto z-10 bg-left grid pt-4 px-16 mx-4 my-8 xl:h-76",
            children: d.type === 'subHeadline' ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-full font-normal text-left text-4xl my-16 xl:text-base xl:my-4",
              "data-aos": "zoom-in",
              "data-aos-duration": "1000",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-left",
                dangerouslySetInnerHTML: {
                  __html: d !== null && d !== void 0 && d.title && d !== null && d !== void 0 && d.description ? (0,translate/* translate */.Iu)(d, 'title', lang) : (0,translate/* translate */.Iu)(d, 'description', lang)
                }
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "m-auto xl:max-w-xl xl:text-left",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
                contents: d,
                center: false
              })
            })
          }, i);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "xl:hidden",
        children: [" ", contents === null || contents === void 0 ? void 0 : (_contents$filter = contents.filter(function (item) {
          return item.name.includes('Q') && item.name !== 'FAQ';
        })) === null || _contents$filter === void 0 ? void 0 : _contents$filter.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        }).map(function (d, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid grid-row-2 ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
              contents: d
            })
          }, i);
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
        contents: (0,translate/* titleOnly */.rT)(contents === null || contents === void 0 ? void 0 : contents.find(function (item) {
          return item.name === "Customer";
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-3 xl:grid-cols-5 gap5 xl:px-48",
        children: (_findContent = (0,translate/* findContent */.IE)(contents, 'Customer')) === null || _findContent === void 0 ? void 0 : _findContent.subContent.filter(function (d) {
          var _d$image;

          return (d === null || d === void 0 ? void 0 : (_d$image = d.image) === null || _d$image === void 0 ? void 0 : _d$image.length) > 0;
        }).map(function (d, i) {
          var _d$image$13, _d$image$14;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "p-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(conent.be).concat((_d$image$13 = d.image[0]) === null || _d$image$13 === void 0 ? void 0 : _d$image$13.url),
              alt: (_d$image$14 = d.image[0]) === null || _d$image$14 === void 0 ? void 0 : _d$image$14.alternativeText,
              className: "h-auto w-36 m-auto xl:w-28",
              "data-aos": "fade-up",
              "data-aos-duration": "1000",
              "data-aos-delay": "".concat(i + 1, "00"),
              loading: "lazy"
            })
          }, i);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full h-fit text-white",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact/* default */.Z, {
        product: "EMEMO",
        event: "e-memoFormSubmit",
        scroll: scroll,
        customContainer: 'Container xxl:mx-auto xxl:px-[6rem]'
      })
    })]
  });
};

EmemoPage.getLayout = function (page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OldLayout/* default */.Z, {
    children: page
  });
};

var __N_SSG = true;
/* harmony default export */ var e_memo = (EmemoPage);

/***/ }),

/***/ 4506:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-memo",
      function () {
        return __webpack_require__(4193);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [735,859,769,60,5,878,371,281,774,888,179], function() { return __webpack_exec__(4506); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);